import { render, staticRenderFns } from "./scrollLayout.vue?vue&type=template&id=093775d4&"
import script from "./scrollLayout.vue?vue&type=script&lang=js&"
export * from "./scrollLayout.vue?vue&type=script&lang=js&"
import style0 from "./scrollLayout.vue?vue&type=style&index=0&id=093775d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports